import { CircleCheck } from "lucide-react";
const foundationFeatures = [];
export default function Foundation() {
  return;
}